/**
 * 5 opponent slots arranged as a shallow ARC (crescent) across the top
 * of the felt. Seat order 0→4 maps to far-left → far-right; the middle
 * seat (index 2) sits highest, the flanks drop toward the hero.
 *
 *   [ _ ]   [ 2 ]   [ _ ]      ← 최상단 중앙
 *        [1]     [3]           ← 중단 양쪽
 *    [0]             [4]       ← 하단 가장자리
 *
 * Arc is expressed via vertical `translateY` per seat; horizontal
 * spacing is handled by `flex justify-between`. Hero reads seating
 * order instantly instead of parsing a flat row.
 */
import type { PersonalityName } from '@/gto/types';
import { OpponentSlot, type OpponentSlotProps } from './OpponentSlot';

export type OpponentDescriptor = Omit<OpponentSlotProps, 'codename' | 'bbSize'> & {
  codename: PersonalityName;
};

export type { OpponentSlotProps };

export type OpponentRingProps = {
  opponents: ReadonlyArray<OpponentDescriptor>;
  /** BB size for unit conversion on each seat. */
  bbSize?: number;
};

export function OpponentRing({ opponents, bbSize = 0 }: OpponentRingProps) {
  return (
    <div
      className="relative flex items-end justify-between pt-2 pb-2 min-h-0"
      data-testid="opponent-ring"
    >
      {opponents.slice(0, 5).map((opp, i) => (
        <div key={opp.codename} className="flex-1 min-w-0">
          <OpponentSlot {...opp} bbSize={bbSize} seatIndex={i} />
        </div>
      ))}
    </div>
  );
}
